import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { HTTPMethod } from 'http-method-enum';
import { API_SPLIT_TRACK, API_SPLIT_TREATMENTS } from '@yoweb/utils/constants/routes';

/**
 * @deprecate pass feature flag state as a page prop via `withFeature('', { passThrough: true })
 * If you have a "global" feature flag (something to flag in a top-level layout) then extend
 * `packages/store/contexts/ExternalConfig.tsx` to pass this flag state and access via `useExternalConfig()`
 */
export var getTreatments = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(splits) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(API_SPLIT_TREATMENTS, {
              method: HTTPMethod.POST,
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(splits)
            });

          case 2:
            res = _context.sent;

            if (res.ok) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", null);

          case 5:
            return _context.abrupt("return", res.json());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTreatments(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var trackEvent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(trafficType, eventType, value, properties) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(API_SPLIT_TRACK, {
              method: HTTPMethod.POST,
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                trafficType: trafficType,
                eventType: eventType,
                value: value,
                properties: properties
              })
            });

          case 2:
            res = _context2.sent;

            if (res.ok) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", null);

          case 5:
            return _context2.abrupt("return", Promise.resolve());

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function trackEvent(_x2, _x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();